import { ReactElement } from "react";

export const joinByComponent = (seperator: ReactElement, components: string[]) =>
  components.length
    ? components.reduce(
        (acc, c, i) => (i < components.length - 1 ? acc.concat(c).concat(seperator) : acc.concat(c)),
        [] as (ReactElement | string)[]
      )
    : components;
